import {
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  Grid,
  Stack,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import Iconify from "src/components/iconify";
import StyledSoftTab from "src/components/styled-soft-tab";
import { InsightsDetail } from "src/types/platforms/medium";

const MediumArticlesDetails = ({ data }: { data: InsightsDetail[] }) => {
  const [value, setValue] = React.useState(0);

  const TABS = data.map((d) => d.title);

  const currentTabData = data[value].value;

  const CARDS_INFO = [
    {
      icon: "hugeicons:time-quarter",
      value: data[value].value["Article Reading Time"],
    },
    {
      icon: "solar:calendar-outline",
      value: data[value].value["Article Date"],
    },
    {
      icon: "ph:hands-clapping-light",
      value: data[value].value["Article Claps Count"],
    },
    {
      icon: "uil:smile",
      value: data[value].value["Article Title Sentiment"],
    },
  ].filter((c) => c.value);

  return (
    <Card>
      <CardContent>
        <Stack spacing={2}>
          <Typography>Article Details</Typography>
          <Divider
            sx={{
              borderStyle: "dashed",
              opacity: 0.24,
              borderColor: "#0B1D60",
            }}
          />
          <Tabs
            value={value}
            TabIndicatorProps={{
              style: {
                display: "none",
              },
            }}
          >
            {TABS.map((tab, index) => (
              <StyledSoftTab
                key={tab}
                selected={value === index}
                title={tab}
                onClick={() => setValue(TABS.indexOf(tab))}
              />
            ))}
          </Tabs>

          {/* Details */}
          <Stack spacing={1}>
            <Stack>
              {currentTabData["Article Title"] && (
                <Typography variant="body1" fontWeight="bold">
                  {currentTabData["Article Title"]}
                </Typography>
              )}
            </Stack>

            <Stack direction="row" spacing={1} alignItems="center">
              <Box
                sx={{ bgcolor: "#000", width: 36, height: 36, borderRadius: "50%" }}
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <Iconify icon="hugeicons:medium" width={24} color="#fff" />
              </Box>
              <Stack>
                {currentTabData["Article Writer"] && (
                  <Typography variant="body2" fontWeight="bold">
                    {currentTabData["Article Writer"]}
                  </Typography>
                )}
                {currentTabData["Article Writer Followers"] && (
                  <Typography variant="caption" color="text.disabled">
                    {currentTabData["Article Writer Followers"]}
                  </Typography>
                )}
              </Stack>
            </Stack>

            {currentTabData["Article Reference"] && (
              <Typography variant="caption" color="text.disabled">
                Video Link:{" "}
                <Link
                  to={currentTabData["Article Reference"]}
                  target="_blank"
                  style={{
                    textDecoration: "none",
                  }}
                >
                  {currentTabData["Article Reference"]}
                </Link>
              </Typography>
            )}

            {CARDS_INFO.length ? (
              <Grid container spacing={2}>
                {CARDS_INFO.map((card, index) => (
                  <Grid item>
                    <Card>
                      <CardContent
                        sx={{
                          bgcolor: "#F1F1F5",
                          p: "2.25px",
                          paddingBottom: "1.25px !important",
                          borderRadius: 10,
                        }}
                      >
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <Iconify icon={card.icon} width={24} height={24} />
                          <Typography variant="caption" color="#555770" fontWeight="bold">
                            {card.value}
                          </Typography>
                        </Stack>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            ) : (
              <></>
            )}
          </Stack>

          <Stack>
            <Typography variant="subtitle2">Tags:</Typography>
            <Typography variant="caption" color="text.disabled">
              {currentTabData["Article Tags"]}
            </Typography>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default MediumArticlesDetails;
